import { render, staticRenderFns } from "./DialogActiveAuth.vue?vue&type=template&id=7770e45f&scoped=true&"
import script from "./DialogActiveAuth.vue?vue&type=script&lang=js&"
export * from "./DialogActiveAuth.vue?vue&type=script&lang=js&"
import style0 from "./DialogActiveAuth.vue?vue&type=style&index=0&id=7770e45f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7770e45f",
  null
  
)

export default component.exports